import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Mail, Globe, Building, FileText } from 'lucide-react';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-50">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={20} />
          Vissza a főoldalra
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8">
          {/* Header */}
          <div className="text-center mb-8 pb-6 border-b border-gray-200">
            <div className="flex justify-center mb-4">
              <Shield className="w-16 h-16 text-blue-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">ADATKEZELÉSI TÁJÉKOZTATÓ</h1>
            <p className="text-lg text-gray-600">ToldFel Videófeltöltő Szolgáltatás</p>
            <div className="mt-4 flex justify-center gap-6 text-sm text-gray-500">
              <span>Hatályos: 2026. január 24.</span>
              <span>Verzió: 1.0</span>
            </div>
          </div>

          {/* Tartalomjegyzék */}
          <nav className="mb-10 p-6 bg-gray-50 rounded-lg">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Tartalomjegyzék</h2>
            <div className="grid md:grid-cols-2 gap-2 text-sm">
              <a href="#section-1" className="text-blue-600 hover:underline">1. Bevezető rendelkezések</a>
              <a href="#section-2" className="text-blue-600 hover:underline">2. Az adatkezelés alapelvei</a>
              <a href="#section-3" className="text-blue-600 hover:underline">3. Az adatkezelés jogalapjai</a>
              <a href="#section-4" className="text-blue-600 hover:underline">4. A kezelt személyes adatok köre</a>
              <a href="#section-5" className="text-blue-600 hover:underline">5. Az adatkezelés időtartama</a>
              <a href="#section-6" className="text-blue-600 hover:underline">6. Adatfeldolgozók és címzettek</a>
              <a href="#section-7" className="text-blue-600 hover:underline">7. Nemzetközi adattovábbítás</a>
              <a href="#section-8" className="text-blue-600 hover:underline">8. Adatbiztonság</a>
              <a href="#section-9" className="text-blue-600 hover:underline">9. Az érintettek jogai</a>
              <a href="#section-10" className="text-blue-600 hover:underline">10. Cookie-k (sütik) kezelése</a>
              <a href="#section-11" className="text-blue-600 hover:underline">11. Automatizált döntéshozatal</a>
              <a href="#section-12" className="text-blue-600 hover:underline">12. Jogorvoslati lehetőségek</a>
              <a href="#section-13" className="text-blue-600 hover:underline">13. A Tájékoztató módosítása</a>
              <a href="#section-14" className="text-blue-600 hover:underline">14. Záró rendelkezések</a>
            </div>
          </nav>

          <div className="prose max-w-none">
            {/* 1. BEVEZETŐ RENDELKEZÉSEK */}
            <section id="section-1" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                1. BEVEZETŐ RENDELKEZÉSEK
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1.1. Az Adatkezelő adatai</h3>
              <div className="bg-blue-50 rounded-lg p-6 mb-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-start gap-3">
                    <Building className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-gray-700">Adatkezelő neve</p>
                      <p className="text-gray-600">Tóth Máté EV.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <FileText className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-gray-700">Székhely</p>
                      <p className="text-gray-600">2040 Budaörs, Mező utca 8/3.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <FileText className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-gray-700">Cégjegyzékszám / Nyilvántartási szám</p>
                      <p className="text-gray-600">7703390</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <FileText className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-gray-700">Adószám</p>
                      <p className="text-gray-600">59654931-1-33</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Mail className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-gray-700">E-mail</p>
                      <p className="text-gray-600">toldf3l@gmail.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Globe className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-gray-700">Weboldal</p>
                      <p className="text-gray-600">https://toldfel.hu</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1.2. Adatvédelmi tisztviselő</h3>
              <p className="text-gray-700 mb-4">
                Az Adatkezelő a GDPR 37. cikke alapján <strong>nem köteles adatvédelmi tisztviselő kijelölésére</strong>, tekintettel arra, hogy:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li>nem minősül közhatalmi szervnek vagy közfeladatot ellátó szervnek;</li>
                <li>alapvető tevékenysége nem olyan adatkezelési műveletek végzése, amelyek jellegüknél, hatókörüknél és/vagy céljaiknál fogva az érintettek rendszeres és szisztematikus, nagymértékű megfigyelését teszik szükségessé;</li>
                <li>alapvető tevékenysége nem különleges adatkategóriák vagy büntetőjogi felelősség megállapítására vonatkozó adatok nagy számban történő kezelése.</li>
              </ul>
              <p className="text-gray-700">
                Adatvédelmi kérdésekben az Adatkezelő az 1.1. pontban megadott e-mail címen áll rendelkezésre.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1.3. A Tájékoztató célja</h3>
              <p className="text-gray-700 mb-4">
                Jelen Adatvédelmi Tájékoztató (a továbbiakban: <strong>Tájékoztató</strong>) célja, hogy az Európai Parlament és a Tanács (EU) 2016/679 rendeletének (a továbbiakban: <strong>GDPR</strong>) 13. és 14. cikkében foglalt tájékoztatási kötelezettségnek megfelelően átfogó információt nyújtson az érintettek részére arról, hogy az Adatkezelő:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li>milyen személyes adatokat gyűjt és kezel;</li>
                <li>milyen célból és jogalapon kezeli az adatokat;</li>
                <li>mennyi ideig tárolja az adatokat;</li>
                <li>kinek továbbítja az adatokat;</li>
                <li>milyen jogok illetik meg az érintetteket;</li>
                <li>hogyan biztosítja az adatok védelmét.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1.4. A Tájékoztató hatálya</h3>
              
              <h4 className="text-lg font-medium text-gray-800 mt-4 mb-3">1.4.1. Személyi hatály</h4>
              <p className="text-gray-700 mb-4">A jelen Tájékoztató hatálya kiterjed:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li>a ToldFel szolgáltatásra regisztráló és azt igénybe vevő természetes személyekre (Felhasználók);</li>
                <li>az Adatkezelő weboldalát látogató természetes személyekre;</li>
                <li>az Adatkezelővel egyéb módon (e-mail, kapcsolatfelvételi űrlap) kapcsolatba lépő természetes személyekre.</li>
              </ul>

              <h4 className="text-lg font-medium text-gray-800 mt-4 mb-3">1.4.2. Tárgyi hatály</h4>
              <p className="text-gray-700 mb-4">
                A Tájékoztató az Adatkezelő által végzett valamennyi személyesadat-kezelési tevékenységre vonatkozik, függetlenül attól, hogy az adatkezelés automatizált eszközökkel vagy manuálisan történik.
              </p>

              <h4 className="text-lg font-medium text-gray-800 mt-4 mb-3">1.4.3. Területi hatály</h4>
              <p className="text-gray-700 mb-4">
                A Tájékoztató hatálya kiterjed az Európai Unió területén tartózkodó érintettek személyes adatainak kezelésére, valamint az Adatkezelő Európai Unión kívüli tevékenységeire is, amennyiben azok az Unió területén tartózkodó érintettek számára áruk vagy szolgáltatások kínálásával, vagy az érintettek Unión belüli viselkedésének megfigyelésével kapcsolatosak.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1.5. Irányadó jogszabályok</h3>
              <p className="text-gray-700 mb-4">Az Adatkezelő adatkezelési tevékenysége során az alábbi jogszabályok rendelkezései az irányadók:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li><strong>GDPR</strong> – Az Európai Parlament és a Tanács (EU) 2016/679 rendelete (2016. április 27.) a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról;</li>
                <li><strong>Info tv.</strong> – Az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény;</li>
                <li><strong>Ptk.</strong> – A Polgári Törvénykönyvről szóló 2013. évi V. törvény;</li>
                <li><strong>Számv. tv.</strong> – A számvitelről szóló 2000. évi C. törvény;</li>
                <li><strong>Eker. tv.</strong> – Az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről szóló 2001. évi CVIII. törvény;</li>
                <li><strong>ePrivacy irányelv</strong> – Az Európai Parlament és a Tanács 2002/58/EK irányelve az elektronikus hírközlési ágazatban a személyes adatok kezeléséről (cookie szabályozás).</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1.6. Fogalommeghatározások</h3>
              <p className="text-gray-700 mb-4">A jelen Tájékoztatóban használt fogalmak a GDPR 4. cikkében meghatározott jelentéssel bírnak:</p>
              
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.1. Személyes adat</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Azonosított vagy azonosítható természetes személyre (érintett) vonatkozó bármely információ. Azonosítható az a természetes személy, aki közvetlen vagy közvetett módon, különösen valamely azonosító, például név, szám, helymeghatározó adat, online azonosító vagy a természetes személy testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező alapján azonosítható.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.2. Adatkezelés</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    A személyes adatokon vagy adatállományokon automatizált vagy nem automatizált módon végzett bármely művelet vagy műveletek összessége, így a gyűjtés, rögzítés, rendszerezés, tagolás, tárolás, átalakítás vagy megváltoztatás, lekérdezés, betekintés, felhasználás, közlés továbbítás, terjesztés vagy egyéb módon történő hozzáférhetővé tétel útján, összehangolás vagy összekapcsolás, korlátozás, törlés, illetve megsemmisítés.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.3. Adatkezelő</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely a személyes adatok kezelésének céljait és eszközeit önállóan vagy másokkal együtt meghatározza. Jelen Tájékoztató vonatkozásában az Adatkezelő az 1.1. pontban meghatározott személy.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.4. Adatfeldolgozó</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely az Adatkezelő nevében személyes adatokat kezel.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.5. Érintett</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Bármely meghatározott, személyes adat alapján azonosított vagy – közvetlenül vagy közvetve – azonosítható természetes személy. Jelen Tájékoztató vonatkozásában érintettnek minősülnek különösen a Felhasználók és a weboldal látogatói.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.6. Az érintett hozzájárulása</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Az érintett akaratának önkéntes, konkrét és megfelelő tájékoztatáson alapuló és egyértelmű kinyilvánítása, amellyel az érintett nyilatkozat vagy a megerősítést félreérthetetlenül kifejező cselekedet útján jelzi, hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.7. Adatvédelmi incidens</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    A biztonság olyan sérülése, amely a továbbított, tárolt vagy más módon kezelt személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését, megváltoztatását, jogosulatlan közlését vagy az azokhoz való jogosulatlan hozzáférést eredményezi.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.8. Címzett</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, akivel vagy amellyel a személyes adatot közlik, függetlenül attól, hogy harmadik fél-e.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.9. Harmadik fél</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely nem azonos az érintettel, az Adatkezelővel, az adatfeldolgozóval vagy azokkal a személyekkel, akik az Adatkezelő vagy adatfeldolgozó közvetlen irányítása alatt a személyes adatok kezelésére felhatalmazást kaptak.
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800">1.6.10. Profilalkotás</h5>
                  <p className="text-gray-700 text-sm mt-2">
                    Személyes adatok automatizált kezelésének bármely olyan formája, amelynek során a személyes adatokat valamely természetes személyhez fűződő bizonyos személyes jellemzők értékelésére, különösen a munkahelyi teljesítményhez, gazdasági helyzethez, egészségi állapothoz, személyes preferenciákhoz, érdeklődéshez, megbízhatósághoz, viselkedéshez, tartózkodási helyhez vagy mozgáshoz kapcsolódó jellemzők elemzésére vagy előrejelzésére használják.
                  </p>
                </div>
              </div>
            </section>

            {/* 2. AZ ADATKEZELÉS ALAPELVEI */}
            <section id="section-2" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                2. AZ ADATKEZELÉS ALAPELVEI
              </h2>
              <p className="text-gray-700 mb-6">
                Az Adatkezelő a személyes adatok kezelése során a GDPR 5. cikkében foglalt alapelveket maradéktalanul betartja:
              </p>

              <div className="space-y-6">
                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.1. Jogszerűség, tisztességes eljárás és átláthatóság</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő a személyes adatokat jogszerűen és tisztességesen, valamint az érintett számára átlátható módon kezeli. Ennek érdekében:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>minden adatkezeléshez megfelelő jogalapot biztosít a GDPR 6. cikke alapján;</li>
                    <li>az érintetteket a jelen Tájékoztató útján előzetesen és közérthető módon tájékoztatja;</li>
                    <li>az adatkezelést úgy végzi, hogy az az érintett számára kiszámítható és követhető legyen;</li>
                    <li>nem kezel személyes adatokat az érintett megtévesztésével vagy a valódi cél elfedésével.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.2. Célhoz kötöttség</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő a személyes adatokat csak meghatározott, egyértelmű és jogszerű célból gyűjti, és azokat nem kezeli ezekkel a célokkal össze nem egyeztethető módon. Az adatkezelési célok:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>a Szolgáltatás nyújtása (videók feltöltése és továbbítása közösségi platformokra);</li>
                    <li>felhasználói fiók kezelése;</li>
                    <li>előfizetések és számlázás kezelése;</li>
                    <li>kapcsolattartás és ügyfélszolgálat;</li>
                    <li>jogszabályi kötelezettségek teljesítése.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.3. Adattakarékosság</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő csak olyan személyes adatokat kezel, amelyek az adatkezelés céljainak megvalósításához szükségesek, és azokat csak a cél eléréséhez feltétlenül szükséges mértékben és ideig tárolja. Ennek érdekében:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>rendszeresen felülvizsgálja a kezelt adatok körét és szükségességét;</li>
                    <li>nem gyűjt és nem tárol a szükségesnél több személyes adatot;</li>
                    <li>a videófájlokat a feltöltés után azonnal törli.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.4. Pontosság</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő a személyes adatokat pontosan és naprakészen tartja, és minden ésszerű intézkedést megtesz annak érdekében, hogy az adatkezelés céljai szempontjából pontatlan adatokat haladéktalanul törölje vagy helyesbítse. Ennek érdekében:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>biztosítja a Felhasználók számára a saját adataik megtekintésének és módosításának lehetőségét;</li>
                    <li>az érintett kérésére haladéktalanul helyesbíti a pontatlan személyes adatokat.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.5. Korlátozott tárolhatóság</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő a személyes adatokat olyan formában tárolja, amely az érintettek azonosítását csak a személyes adatok kezelése céljainak eléréséhez szükséges ideig teszi lehetővé. Ennek érdekében:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>minden adatkezelési célhoz meghatározza az adatok tárolásának időtartamát;</li>
                    <li>a megőrzési idő lejártát követően a személyes adatokat törli vagy anonimizálja;</li>
                    <li>automatikus törlési mechanizmusokat alkalmaz.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.6. Integritás és bizalmas jelleg</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő a személyes adatok kezelését oly módon végzi, hogy megfelelő technikai és szervezési intézkedések alkalmazásával biztosítva legyen a személyes adatok megfelelő biztonsága. Ennek érdekében:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>megfelelő technikai intézkedéseket alkalmaz (titkosítás, hozzáférés-szabályozás);</li>
                    <li>szervezési intézkedéseket vezet be (jogosultságkezelés);</li>
                    <li>védi az adatokat jogosulatlan hozzáférés, elvesztés, megsemmisítés ellen.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">2.7. Elszámoltathatóság</h3>
                  <p className="text-gray-700 mb-2">
                    Az Adatkezelő felelős a fenti alapelveknek való megfelelésért, és képes e megfelelés igazolására. Ennek érdekében:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li>naprakész nyilvántartást vezet az adatkezelési tevékenységekről;</li>
                    <li>dokumentálja az adatvédelmi intézkedéseket;</li>
                    <li>rendszeresen felülvizsgálja az adatkezelési gyakorlatot.</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* 3. AZ ADATKEZELÉS JOGALAPJAI */}
            <section id="section-3" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                3. AZ ADATKEZELÉS JOGALAPJAI
              </h2>
              <p className="text-gray-700 mb-6">
                Az Adatkezelő a személyes adatokat kizárólag a GDPR 6. cikkében meghatározott jogalapok valamelyike alapján kezeli:
              </p>

              <div className="space-y-6">
                <div className="bg-green-50 p-6 rounded-lg">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">3.1. Az érintett hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont)</h3>
                  <p className="text-gray-700 mb-3">
                    Az érintett hozzájárulást adott személyes adatainak egy vagy több konkrét célból történő kezeléséhez.
                  </p>
                  <p className="text-gray-700 mb-3"><strong>Alkalmazási körök a ToldFel szolgáltatásban:</strong></p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
                    <li><strong>Marketing célú kommunikáció:</strong> Hírlevél küldése, promóciós anyagok továbbítása;</li>
                    <li><strong>Cookie-k használata:</strong> Analitikai és marketing célú cookie-k elhelyezése;</li>
                    <li><strong>Kapcsolatfelvétel:</strong> A weboldalon keresztül történő érdeklődés esetén az önkéntesen megadott adatok kezelése.</li>
                  </ul>
                  <div className="bg-white p-4 rounded border border-green-200">
                    <p className="text-gray-700 text-sm mb-2"><strong>A hozzájárulás jellemzői:</strong></p>
                    <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
                      <li><strong>Önkéntes:</strong> Az érintett valódi választási lehetőséggel rendelkezik;</li>
                      <li><strong>Konkrét:</strong> A hozzájárulás meghatározott adatkezelési célra vonatkozik;</li>
                      <li><strong>Tájékoztatáson alapuló:</strong> Az érintett megfelelő információkat kap az adatkezelésről;</li>
                      <li><strong>Egyértelmű:</strong> Aktív magatartással (pl. jelölőnégyzet) kell megadni.</li>
                    </ul>
                  </div>
                  <p className="text-gray-700 mt-4 text-sm">
                    <strong>A hozzájárulás visszavonása:</strong> Az érintett jogosult arra, hogy hozzájárulását bármikor visszavonja. A visszavonás nem érinti a visszavonás előtti adatkezelés jogszerűségét.
                  </p>
                </div>

                <div className="bg-blue-50 p-6 rounded-lg">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">3.2. Szerződés teljesítése (GDPR 6. cikk (1) bekezdés b) pont)</h3>
                  <p className="text-gray-700 mb-3">
                    Az adatkezelés olyan szerződés teljesítéséhez szükséges, amelyben az érintett az egyik fél, vagy az a szerződés megkötését megelőzően az érintett kérésére történő lépések megtételéhez szükséges.
                  </p>
                  <p className="text-gray-700 mb-3"><strong>Alkalmazási körök a ToldFel szolgáltatásban:</strong></p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    <li><strong>Regisztráció és felhasználói fiók létrehozása:</strong> E-mail cím, jelszó (titkosított formában);</li>
                    <li><strong>A Szolgáltatás alapfunkcióinak biztosítása:</strong> Videók feltöltése és továbbítása a kiválasztott platformokra;</li>
                    <li><strong>Platform-összekapcsolások kezelése:</strong> OAuth tokenek, platformazonosítók tárolása;</li>
                    <li><strong>Előfizetési és fizetési műveletek:</strong> Előfizetési díjak kezelése, számlák kiállítása;</li>
                    <li><strong>Kommunikáció a Szolgáltatással kapcsolatban:</strong> Szolgáltatással kapcsolatos értesítések, technikai támogatás.</li>
                  </ul>
                </div>

                <div className="bg-yellow-50 p-6 rounded-lg">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">3.3. Jogi kötelezettség teljesítése (GDPR 6. cikk (1) bekezdés c) pont)</h3>
                  <p className="text-gray-700 mb-3">
                    Az adatkezelés az Adatkezelőre vonatkozó jogi kötelezettség teljesítéséhez szükséges.
                  </p>
                  <p className="text-gray-700 mb-3"><strong>Alkalmazási körök a ToldFel szolgáltatásban:</strong></p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
                    <li><strong>Számviteli és adózási kötelezettségek:</strong> A számvitelről szóló 2000. évi C. törvény 169. § (2) bekezdése alapján a számlák és bizonylatok 8 évig való megőrzése;</li>
                    <li><strong>Hatósági megkeresések teljesítése:</strong> Jogszabályi kötelezettség alapján történő együttműködés hatóságokkal.</li>
                  </ul>
                  <p className="text-gray-700 text-sm"><strong>Kezelt adatok:</strong> Számlázási név és cím, adószám, fizetési tranzakciók adatai.</p>
                </div>

                <div className="bg-purple-50 p-6 rounded-lg">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">3.4. Jogos érdek (GDPR 6. cikk (1) bekezdés f) pont)</h3>
                  <p className="text-gray-700 mb-3">
                    Az adatkezelés az Adatkezelő vagy egy harmadik fél jogos érdekeinek érvényesítéséhez szükséges, kivéve, ha ezen érdekekkel szemben elsőbbséget élveznek az érintett érdekei vagy alapvető jogai.
                  </p>
                  <p className="text-gray-700 mb-3"><strong>Alkalmazási körök a ToldFel szolgáltatásban:</strong></p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>
                      <strong>A Szolgáltatás biztonságának fenntartása:</strong> Csalás és visszaélés megelőzése, jogosulatlan hozzáférés elleni védelem, biztonsági incidensek kivizsgálása.
                      <p className="text-sm text-gray-600 mt-1"><em>Érdekmérlegelés:</em> A biztonság fenntartása alapvető érdek, amely nem korlátozza aránytalanul az érintettek jogait.</p>
                    </li>
                    <li>
                      <strong>A Szolgáltatás fejlesztése és optimalizálása:</strong> Használati statisztikák elemzése (anonimizált formában), hibajavítások.
                      <p className="text-sm text-gray-600 mt-1"><em>Érdekmérlegelés:</em> A szolgáltatásminőség javítása mind az Adatkezelő, mind a Felhasználók érdekét szolgálja.</p>
                    </li>
                    <li>
                      <strong>Jogi igények előterjesztése, érvényesítése és védelme:</strong> Követelések érvényesítéséhez szükséges adatok megőrzése.
                      <p className="text-sm text-gray-600 mt-1"><em>Érdekmérlegelés:</em> Az adatmegőrzés az általános elévülési időhöz (5 év) igazodik.</p>
                    </li>
                  </ul>
                  <div className="bg-white p-4 rounded border border-purple-200 mt-4">
                    <p className="text-gray-700 text-sm">
                      <strong>Tiltakozási jog:</strong> Az érintett jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak jogos érdeken alapuló kezelése ellen.
                    </p>
                  </div>
                </div>
              </div>

              {/* Összefoglaló táblázat */}
              <h3 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3.5. Összefoglaló táblázat</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Adatkezelési cél</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Jogalap</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr><td className="border border-gray-300 px-4 py-2">Szolgáltatás nyújtása (videófeltöltés)</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) b) – szerződés teljesítése</td></tr>
                    <tr className="bg-gray-50"><td className="border border-gray-300 px-4 py-2">Regisztráció és fiókkezelés</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) b) – szerződés teljesítése</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">Platform-összekapcsolások (OAuth)</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) b) – szerződés teljesítése</td></tr>
                    <tr className="bg-gray-50"><td className="border border-gray-300 px-4 py-2">Előfizetés kezelése</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) b) – szerződés teljesítése</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">Számlázás</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) c) – jogi kötelezettség</td></tr>
                    <tr className="bg-gray-50"><td className="border border-gray-300 px-4 py-2">Kapcsolattartás (szolgáltatással kapcsolatos)</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) b) – szerződés teljesítése</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">Kapcsolatfelvételi űrlap</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) a) – hozzájárulás</td></tr>
                    <tr className="bg-gray-50"><td className="border border-gray-300 px-4 py-2">Hírlevél küldés</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) a) – hozzájárulás</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">Statisztika (Google Analytics)</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) a) – hozzájárulás</td></tr>
                    <tr className="bg-gray-50"><td className="border border-gray-300 px-4 py-2">Rendszerbiztonság, naplózás</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) f) – jogos érdek</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">Jogi igények érvényesítése</td><td className="border border-gray-300 px-4 py-2">GDPR 6. cikk (1) f) – jogos érdek</td></tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* 4. A KEZELT SZEMÉLYES ADATOK KÖRE */}
            <section id="section-4" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                4. A KEZELT SZEMÉLYES ADATOK KÖRE ÉS AZ ADATKEZELÉS CÉLJAI
              </h2>
              <p className="text-gray-700 mb-6">
                Az Adatkezelő a ToldFel szolgáltatás nyújtása során az alábbi személyes adatokat kezeli. Az adatkezelés minden esetben a GDPR 5. cikkében foglalt alapelveknek megfelelően, a szükséges minimumra korlátozva történik.
              </p>

              {/* 4.1 Regisztrációs adatok */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.1. Regisztrációs és azonosítási adatok</h3>
              <p className="text-gray-700 mb-4">A Szolgáltatás igénybevételéhez szükséges regisztráció és a Felhasználó azonosítása céljából:</p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">E-mail cím</td>
                      <td className="border border-gray-300 px-3 py-2">Felhasználói fiók azonosítása, bejelentkezés, kommunikáció</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig + 5 év</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Jelszó (titkosított hash)</td>
                      <td className="border border-gray-300 px-3 py-2">Biztonságos bejelentkezés és hitelesítés</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Felhasználói azonosító (userId)</td>
                      <td className="border border-gray-300 px-3 py-2">Technikai azonosítás, adatok összerendelése</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig + 5 év</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Regisztráció dátuma</td>
                      <td className="border border-gray-300 px-3 py-2">Szerződéses jogviszony kezdetének dokumentálása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig + 5 év</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Utolsó bejelentkezés időpontja</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók aktivitásának nyomon követése, biztonság</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-gray-600 text-sm mb-6">
                <strong>Megjegyzés:</strong> A jelszavakat az Adatkezelő kizárólag egyirányú titkosított (hash) formában tárolja, az eredeti jelszó visszafejtése nem lehetséges.
              </p>

              {/* 4.2 Előfizetési adatok */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.2. Előfizetési és számlázási adatok</h3>
              <p className="text-gray-700 mb-4">Az előfizetések kezelése és a számlázás céljából:</p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Előfizetési csomag típusa</td>
                      <td className="border border-gray-300 px-3 py-2">Jogosultságok meghatározása (Free/Premium)</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Előfizetés státusza</td>
                      <td className="border border-gray-300 px-3 py-2">Aktív/lejárt állapot követése</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Előfizetés kezdete és vége</td>
                      <td className="border border-gray-300 px-3 py-2">Számlázási periódusok meghatározása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">8 év (Számv. tv.)</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Stripe ügyfél-azonosító</td>
                      <td className="border border-gray-300 px-3 py-2">Fizetési szolgáltatóval való összerendelés</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Számlázási név és cím</td>
                      <td className="border border-gray-300 px-3 py-2">Számla kiállítása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) c)</td>
                      <td className="border border-gray-300 px-3 py-2">8 év (Számv. tv.)</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Adószám (B2B)</td>
                      <td className="border border-gray-300 px-3 py-2">Számla kiállítása cégek részére</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) c)</td>
                      <td className="border border-gray-300 px-3 py-2">8 év (Számv. tv.)</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Fizetési tranzakciók adatai</td>
                      <td className="border border-gray-300 px-3 py-2">Fizetések nyilvántartása és egyeztetése</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b) és c)</td>
                      <td className="border border-gray-300 px-3 py-2">8 év (Számv. tv.)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-gray-700 text-sm">
                  <strong>Fontos:</strong> A bankkártya-adatokat a Szolgáltató <strong>NEM kezeli</strong>. A fizetési adatokat közvetlenül a <strong>Stripe</strong> fizetési szolgáltató kezeli, PCI DSS tanúsítvánnyal.
                </p>
              </div>

              {/* 4.3 Platform adatok */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.3. Közösségi platform-összekapcsolási adatok (OAuth)</h3>
              <p className="text-gray-700 mb-4">A videófeltöltés technikai lebonyolításához szükséges platform-hozzáférések kezelése céljából:</p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Facebook/Meta OAuth token</td>
                      <td className="border border-gray-300 px-3 py-2">Facebook oldalakra történő videófeltöltés</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Facebook oldal azonosítók</td>
                      <td className="border border-gray-300 px-3 py-2">Céloldal kiválasztása feltöltéshez</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">TikTok OAuth token</td>
                      <td className="border border-gray-300 px-3 py-2">TikTok fiókba történő videófeltöltés</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">TikTok felhasználói azonosító</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók azonosítása feltöltéshez</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">YouTube/Google OAuth token</td>
                      <td className="border border-gray-300 px-3 py-2">YouTube csatornára történő videófeltöltés</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">YouTube csatorna azonosítók</td>
                      <td className="border border-gray-300 px-3 py-2">Célcsatorna kiválasztása feltöltéshez</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* OAuth adatok részletes leírása */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
                <h4 className="font-semibold text-gray-800 mb-3">OAuth adatok kezelésének részletei</h4>
                
                <div className="space-y-4">
                  <div>
                    <h5 className="font-medium text-gray-700">Hozzáférés a platform adatokhoz (Data Accessed)</h5>
                    <p className="text-gray-600 text-sm mt-1">
                      Az Adatkezelő az alábbi adatokhoz fér hozzá az OAuth kapcsolatokon keresztül:
                    </p>
                    <ul className="list-disc pl-6 text-gray-600 text-sm mt-2 space-y-1">
                      <li><strong>Facebook:</strong> Kezelt Facebook oldalak listája, oldal azonosítók, videófeltöltési jogosultság</li>
                      <li><strong>TikTok:</strong> Felhasználónév, profilkép, videófeltöltési jogosultság</li>
                      <li><strong>YouTube:</strong> Csatorna név, csatorna azonosító, videófeltöltési jogosultság</li>
                    </ul>
                    <p className="text-gray-600 text-sm mt-2">
                      Az Adatkezelő <strong>NEM fér hozzá</strong> a Felhasználó személyes üzeneteihez, ismerőslistájához, naptárához vagy egyéb privát adataihoz.
                    </p>
                  </div>

                  <div>
                    <h5 className="font-medium text-gray-700">Adatok felhasználása (Data Usage)</h5>
                    <p className="text-gray-600 text-sm mt-1">
                      A hozzáférési adatokat az Adatkezelő <strong>kizárólag</strong> az alábbi célokra használja:
                    </p>
                    <ul className="list-disc pl-6 text-gray-600 text-sm mt-2 space-y-1">
                      <li>Videók feltöltése a kiválasztott platformokra a Felhasználó nevében</li>
                      <li>A feltöltés státuszának ellenőrzése</li>
                      <li>A kapcsolat fenntartása a kiválasztott oldallal/csatornával</li>
                    </ul>
                    <p className="text-gray-600 text-sm mt-2">
                      Az Adatkezelő <strong>NEM használja</strong> a token-eket egyéb műveletekre (pl. posztolás, kommentelés, lájkolás, követés).
                    </p>
                  </div>

                  <div>
                    <h5 className="font-medium text-gray-700">Adatok tárolása és védelme (Data Storage & Protection)</h5>
                    <ul className="list-disc pl-6 text-gray-600 text-sm mt-2 space-y-1">
                      <li>OAuth tokenek titkosított formában kerülnek tárolásra (AES-256)</li>
                      <li>Az adatok az EU területén (Svédország – Stockholm) lévő szervereken tárolódnak</li>
                      <li>A hozzáférés szigorúan korlátozott és naplózott</li>
                      <li>Access tokenek rövid élettartamúak, refresh tokenek biztonságosan tárolva</li>
                    </ul>
                  </div>

                  <div>
                    <h5 className="font-medium text-gray-700">Adatok törlése (Data Deletion)</h5>
                    <p className="text-gray-600 text-sm mt-1">
                      A Felhasználó bármikor bonthatja a platform-kapcsolatot:
                    </p>
                    <ul className="list-disc pl-6 text-gray-600 text-sm mt-2 space-y-1">
                      <li>A Beállítások / Kapcsolatok menüpontban a „Kapcsolat bontása" gombbal</li>
                      <li>A kapcsolat bontásakor az OAuth tokenek és azonosítók azonnal törlésre kerülnek</li>
                      <li>A feltöltési előzmények (metaadatok) a feltöltési naplóban megmaradnak</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 4.4 Videófájlok */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.4. Videófájlok kezelése</h3>
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Fontos:</strong> A Szolgáltató <strong>nem tárolja</strong> a feltöltött videókat tartósan.
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>A videófájlok kizárólag a feltöltés, továbbítás és technikai feldolgozás idejére kerülnek a rendszerbe.</li>
                  <li>A továbbítás befejezését követően a videófájlok <strong>automatikusan és véglegesen törlésre kerülnek</strong>.</li>
                  <li>A videók tartalma, metaadatai nem kerülnek elemzésre vagy archiválásra.</li>
                </ul>
              </div>

              {/* 4.5 Feltöltési előzmények */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.5. Feltöltési előzmények</h3>
              <p className="text-gray-700 mb-4">A feltöltési műveletek dokumentálása céljából:</p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Feltöltés azonosító</td>
                      <td className="border border-gray-300 px-3 py-2">Egyedi azonosítás, hivatkozás</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Feltöltés időpontja</td>
                      <td className="border border-gray-300 px-3 py-2">Előzmények megjelenítése</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Célplatformok</td>
                      <td className="border border-gray-300 px-3 py-2">Hova történt a feltöltés</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Feltöltés státusza</td>
                      <td className="border border-gray-300 px-3 py-2">Sikeres/sikertelen állapot</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Videó címe (metaadat)</td>
                      <td className="border border-gray-300 px-3 py-2">Előzmények azonosítása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* 4.6 Kommunikációs adatok */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.6. Kommunikációs adatok</h3>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolatfelvételi üzenet tartalma</td>
                      <td className="border border-gray-300 px-3 py-2">Kérdések megválaszolása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) a)</td>
                      <td className="border border-gray-300 px-3 py-2">2 év</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Hírlevél feliratkozás</td>
                      <td className="border border-gray-300 px-3 py-2">Marketing kommunikáció</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) a)</td>
                      <td className="border border-gray-300 px-3 py-2">Leiratkozásig</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Rendszerüzenetek naplója</td>
                      <td className="border border-gray-300 px-3 py-2">Szolgáltatással kapcsolatos értesítések</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                      <td className="border border-gray-300 px-3 py-2">1 év</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* 4.7 Technikai adatok */}
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4.7. Technikai és naplózási adatok</h3>
              <p className="text-gray-700 mb-4">A Szolgáltatás biztonságos és megbízható működése érdekében:</p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">IP-cím (anonimizálva)</td>
                      <td className="border border-gray-300 px-3 py-2">Biztonsági célok, visszaélések megelőzése</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                      <td className="border border-gray-300 px-3 py-2">90 nap</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Böngésző típusa (User Agent)</td>
                      <td className="border border-gray-300 px-3 py-2">Kompatibilitás biztosítása, hibaelhárítás</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                      <td className="border border-gray-300 px-3 py-2">90 nap</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Operációs rendszer</td>
                      <td className="border border-gray-300 px-3 py-2">Kompatibilitás biztosítása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                      <td className="border border-gray-300 px-3 py-2">90 nap</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Bejelentkezési események</td>
                      <td className="border border-gray-300 px-3 py-2">Biztonsági napló</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                      <td className="border border-gray-300 px-3 py-2">1 év</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Hibák és kivételek (error logs)</td>
                      <td className="border border-gray-300 px-3 py-2">Szolgáltatás minőségének biztosítása</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                      <td className="border border-gray-300 px-3 py-2">30 nap</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Google Analytics adatok</td>
                      <td className="border border-gray-300 px-3 py-2">Használati statisztikák</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) a)</td>
                      <td className="border border-gray-300 px-3 py-2">14 hónap</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* 5. AZ ADATKEZELÉS IDŐTARTAMA */}
            <section id="section-5" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                5. AZ ADATKEZELÉS IDŐTARTAMA
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">5.1. Általános elvek</h3>
              <p className="text-gray-700 mb-4">
                Az Adatkezelő a személyes adatokat kizárólag az adatkezelési cél megvalósulásához szükséges ideig, illetve a vonatkozó jogszabályokban meghatározott kötelező megőrzési időtartamig kezeli.
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li><strong>Célhoz kötöttség:</strong> A személyes adatok tárolása kizárólag addig történik, amíg az eredeti adatkezelési cél ezt szükségessé teszi.</li>
                <li><strong>Jogszabályi kötelezettség:</strong> Bizonyos adatok esetében jogszabály írja elő a megőrzési időt (pl. számviteli bizonylatok 8 év).</li>
                <li><strong>Korlátozott tárolhatóság:</strong> Az Adatkezelő rendszeres felülvizsgálatot végez a személyes adatok törléséről.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">5.2. Összefoglaló táblázat</h3>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adatkategória</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megőrzési idő</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogszabályi alap</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Regisztrációs adatok (e-mail, userId)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig + 5 év (elévülés)</td>
                      <td className="border border-gray-300 px-3 py-2">Ptk. 6:22. §</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Jelszó (hash)</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Számlázási adatok</td>
                      <td className="border border-gray-300 px-3 py-2">8 év</td>
                      <td className="border border-gray-300 px-3 py-2">Számv. tv. 169. § (2)</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Platform OAuth tokenek</td>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolat bontásáig</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Videófájlok</td>
                      <td className="border border-gray-300 px-3 py-2">Feltöltés befejezéséig (percek)</td>
                      <td className="border border-gray-300 px-3 py-2">Automatikus törlés</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Feltöltési előzmények</td>
                      <td className="border border-gray-300 px-3 py-2">Fiók törléséig</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) b)</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Kapcsolatfelvételi üzenetek</td>
                      <td className="border border-gray-300 px-3 py-2">2 év</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) a)</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Hírlevél feliratkozás</td>
                      <td className="border border-gray-300 px-3 py-2">Leiratkozásig</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) a)</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">IP-cím, böngésző adatok</td>
                      <td className="border border-gray-300 px-3 py-2">90 nap</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Bejelentkezési napló</td>
                      <td className="border border-gray-300 px-3 py-2">1 év</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2">Error logs</td>
                      <td className="border border-gray-300 px-3 py-2">30 nap</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) f)</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2">Google Analytics</td>
                      <td className="border border-gray-300 px-3 py-2">14 hónap</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6. cikk (1) a)</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">5.3. Fiók törlése utáni adatkezelés</h3>
              <p className="text-gray-700 mb-4">A Felhasználói fiók törlése esetén:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li><strong>Azonnal törlésre kerül:</strong> Jelszó, OAuth tokenek, beállítások, feltöltési előzmények</li>
                <li><strong>30 napos visszaállítási időszak (soft delete):</strong> A fiók és adatok visszaállíthatók kérésre</li>
                <li><strong>Jogszabályi kötelezettség miatt megőrzött:</strong> Számlázási adatok 8 évig zárolva tárolódnak</li>
                <li><strong>Elévülési idő végéig:</strong> A felhasználói azonosító anonimizálva 5 évig megmarad jogi igények kezeléséhez</li>
              </ul>
            </section>

            {/* 6. ADATFELDOLGOZÓK ÉS CÍMZETTEK */}
            <section id="section-6" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                6. ADATFELDOLGOZÓK ÉS CÍMZETTEK
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">6.1. Adatfeldolgozók fogalma</h3>
              <p className="text-gray-700 mb-4">
                A GDPR 4. cikk 8. pontja szerint adatfeldolgozó az a természetes vagy jogi személy, amely az Adatkezelő nevében személyes adatokat kezel. Az Adatkezelő minden adatfeldolgozóval írásbeli szerződést (Data Processing Agreement, DPA) kötött a GDPR 28. cikke alapján.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">6.2. Adatfeldolgozók listája</h3>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adatfeldolgozó</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Székhely</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Adatkezelés helye</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Megfelelőség</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2 font-medium">Supabase Inc.</td>
                      <td className="border border-gray-300 px-3 py-2">Backend, adatbázis, autentikáció</td>
                      <td className="border border-gray-300 px-3 py-2">USA</td>
                      <td className="border border-gray-300 px-3 py-2">Stockholm, Svédország (EU)</td>
                      <td className="border border-gray-300 px-3 py-2">EU-US DPF, SCC</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2 font-medium">Stripe, Inc.</td>
                      <td className="border border-gray-300 px-3 py-2">Fizetésfeldolgozás</td>
                      <td className="border border-gray-300 px-3 py-2">USA / Írország</td>
                      <td className="border border-gray-300 px-3 py-2">EU (Írország)</td>
                      <td className="border border-gray-300 px-3 py-2">PCI DSS, EU-US DPF</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2 font-medium">Meta Platforms, Inc.</td>
                      <td className="border border-gray-300 px-3 py-2">Facebook videófeltöltés API</td>
                      <td className="border border-gray-300 px-3 py-2">USA / Írország</td>
                      <td className="border border-gray-300 px-3 py-2">EU / USA</td>
                      <td className="border border-gray-300 px-3 py-2">EU-US DPF, SCC</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2 font-medium">Google LLC</td>
                      <td className="border border-gray-300 px-3 py-2">YouTube API, Analytics</td>
                      <td className="border border-gray-300 px-3 py-2">USA</td>
                      <td className="border border-gray-300 px-3 py-2">EU / USA</td>
                      <td className="border border-gray-300 px-3 py-2">EU-US DPF, ISO 27001</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2 font-medium">ByteDance Ltd. (TikTok)</td>
                      <td className="border border-gray-300 px-3 py-2">TikTok videófeltöltés API</td>
                      <td className="border border-gray-300 px-3 py-2">Szingapúr / Írország</td>
                      <td className="border border-gray-300 px-3 py-2">EU (Írország) / USA / Szingapúr</td>
                      <td className="border border-gray-300 px-3 py-2">SCC, TikTok EU-adatpolitika</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2 font-medium">Oracle Corporation</td>
                      <td className="border border-gray-300 px-3 py-2">Frontend hosting</td>
                      <td className="border border-gray-300 px-3 py-2">USA</td>
                      <td className="border border-gray-300 px-3 py-2">Stockholm, Svédország (EU)</td>
                      <td className="border border-gray-300 px-3 py-2">EU-US DPF, SCC</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">6.3. Közösségi platformok (harmadik fél adatkezelők)</h3>
              <p className="text-gray-700 mb-4">
                A ToldFel szolgáltatás a Felhasználó nevében adatokat továbbít az alábbi közösségi platformok felé. Ezen platformok <strong>önálló adatkezelők</strong>, saját adatvédelmi szabályzattal rendelkeznek:
              </p>
              <div className="grid md:grid-cols-3 gap-4 mb-6">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Meta Platforms (Facebook)</h4>
                  <p className="text-sm text-gray-600 mb-2">Adatvédelmi szabályzat:</p>
                  <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm hover:underline break-all">facebook.com/privacy/policy</a>
                </div>
                <div className="bg-red-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Google (YouTube)</h4>
                  <p className="text-sm text-gray-600 mb-2">Adatvédelmi szabályzat:</p>
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm hover:underline break-all">policies.google.com/privacy</a>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">ByteDance (TikTok)</h4>
                  <p className="text-sm text-gray-600 mb-2">Adatvédelmi szabályzat:</p>
                  <a href="https://www.tiktok.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm hover:underline break-all">tiktok.com/legal/privacy-policy</a>
                </div>
              </div>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-gray-700 text-sm">
                  <strong>Fontos:</strong> Az adattovábbítás kizárólag a Felhasználó által engedélyezett műveletekre (videófeltöltés) terjed ki. A Szolgáltató nem felel a platformok saját adatkezelési gyakorlatáért.
                </p>
              </div>
            </section>

            {/* 7. NEMZETKÖZI ADATTOVÁBBÍTÁS */}
            <section id="section-7" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                7. NEMZETKÖZI ADATTOVÁBBÍTÁS
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">7.1. Adattovábbítás az EGT-n kívülre</h3>
              <p className="text-gray-700 mb-4">
                Az Adatkezelő által igénybe vett egyes szolgáltatók az Európai Gazdasági Térségen (EGT) kívül, elsősorban az Egyesült Államokban székhellyel rendelkeznek. Az EGT-n kívüli adattovábbítás az alábbi megfelelőségi mechanizmusok alapján történik:
              </p>

              <div className="space-y-4 mb-6">
                <div className="border-l-4 border-green-500 pl-4">
                  <h4 className="font-semibold text-gray-800">7.1.1. EU-US Data Privacy Framework (EU-US DPF)</h4>
                  <p className="text-gray-700 text-sm mt-2">
                    Az Európai Bizottság 2023. július 10-i megfelelőségi határozata alapján az EU-US Data Privacy Framework keretrendszerben tanúsítvánnyal rendelkező amerikai vállalatok megfelelő szintű adatvédelmet biztosítanak. Az Adatkezelő adatfeldolgozói közül a következők rendelkeznek DPF tanúsítvánnyal:
                  </p>
                  <ul className="list-disc pl-6 text-gray-600 text-sm mt-2">
                    <li>Google LLC</li>
                    <li>Meta Platforms, Inc.</li>
                    <li>Stripe, Inc.</li>
                    <li>Oracle Corporation</li>
                    <li>Supabase Inc.</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-4">
                  <h4 className="font-semibold text-gray-800">7.1.2. Standard Contractual Clauses (SCC)</h4>
                  <p className="text-gray-700 text-sm mt-2">
                    A GDPR 46. cikk (2) bekezdés c) pontja szerinti általános szerződési feltételek (SCC) alkalmazásával az Adatkezelő biztosítja a megfelelő garanciákat az adattovábbításhoz. Az SCC az Európai Bizottság által jóváhagyott szerződéses kikötéseket tartalmaz.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">7.2. Tényleges adatkezelési helyek</h3>
              <p className="text-gray-700 mb-4">
                Bár egyes szolgáltatók USA-beli székhelyűek, a <strong>tényleges adatkezelés</strong> az alábbi helyeken történik:
              </p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Szolgáltató</th>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Adatkezelés helye</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">Supabase (backend, adatbázis)</td>
                      <td className="border border-gray-300 px-4 py-2"><strong>Stockholm, Svédország (EU)</strong></td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2">Oracle (frontend hosting)</td>
                      <td className="border border-gray-300 px-4 py-2"><strong>Stockholm, Svédország (EU)</strong></td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">Stripe (fizetés)</td>
                      <td className="border border-gray-300 px-4 py-2"><strong>Dublin, Írország (EU)</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* 8. ADATBIZTONSÁG */}
            <section id="section-8" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                8. ADATBIZTONSÁG
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">8.1. Technikai intézkedések</h3>
              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Titkosítás</h4>
                  <ul className="list-disc pl-4 text-gray-700 text-sm space-y-1">
                    <li>HTTPS/TLS 1.3 minden kommunikációhoz</li>
                    <li>AES-256 titkosítás nyugalmi állapotban</li>
                    <li>Jelszavak bcrypt hash algoritmussal</li>
                    <li>OAuth tokenek titkosított tárolása</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Hozzáférés-szabályozás</h4>
                  <ul className="list-disc pl-4 text-gray-700 text-sm space-y-1">
                    <li>Row Level Security (RLS) az adatbázisban</li>
                    <li>JWT alapú autentikáció</li>
                    <li>Jogosultságkezelés (felhasználói szerepkörök)</li>
                    <li>API kulcsok biztonságos kezelése</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Infrastruktúra biztonság</h4>
                  <ul className="list-disc pl-4 text-gray-700 text-sm space-y-1">
                    <li>Tűzfal és DDoS védelem</li>
                    <li>Rendszeres biztonsági mentések</li>
                    <li>Szerver oldali validáció</li>
                    <li>SQL injection és XSS védelem</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-2">Monitoring</h4>
                  <ul className="list-disc pl-4 text-gray-700 text-sm space-y-1">
                    <li>Folyamatos rendszerfigyelés</li>
                    <li>Gyanús aktivitás észlelése</li>
                    <li>Hibanaplózás és riasztások</li>
                    <li>Rendszeres biztonsági auditok</li>
                  </ul>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">8.2. Szervezési intézkedések</h3>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li><strong>Adatvédelmi szempontú tervezés (Privacy by Design):</strong> Az adatvédelem már a tervezési fázistól beépül a rendszerbe.</li>
                <li><strong>Alapértelmezett adatvédelem (Privacy by Default):</strong> A rendszer alapértelmezés szerint csak a szükséges minimális adatokat gyűjti.</li>
                <li><strong>Adatminimalizálás:</strong> Csak a feltétlenül szükséges adatok kerülnek gyűjtésre és tárolásra.</li>
                <li><strong>Hozzáférés korlátozása:</strong> A személyes adatokhoz csak az arra jogosult személyek férhetnek hozzá.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">8.3. Adatvédelmi incidensek kezelése</h3>
              <p className="text-gray-700 mb-4">
                Az Adatkezelő a GDPR 33. és 34. cikkével összhangban eljárásrendet alakított ki az adatvédelmi incidensek kezelésére:
              </p>
              <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-6">
                <h4 className="font-semibold text-gray-800 mb-3">Incidens esetén</h4>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li><strong>Felügyeleti hatóság értesítése:</strong> A NAIH értesítése <strong>72 órán belül</strong>, ha az incidens valószínűsíthetően kockázattal jár az érintettek jogaira.</li>
                  <li><strong>Érintettek értesítése:</strong> Haladéktalan tájékoztatás, ha az incidens valószínűsíthetően <strong>magas kockázattal</strong> jár.</li>
                  <li><strong>Dokumentálás:</strong> Minden incidens nyilvántartásba kerül (időpont, leírás, következmények, megtett intézkedések).</li>
                  <li><strong>Korrekciós intézkedések:</strong> Azonnali lépések a kár minimalizálására és a jövőbeli incidensek megelőzésére.</li>
                </ul>
              </div>
            </section>

            {/* 9. AZ ÉRINTETTEK JOGAI */}
            <section id="section-9" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                9. AZ ÉRINTETTEK JOGAI
              </h2>
              <p className="text-gray-700 mb-6">
                Az Adatkezelő kiemelt figyelmet fordít arra, hogy az érintettek a GDPR által biztosított jogaikat maradéktalanul gyakorolhassák.
              </p>

              <div className="space-y-6">
                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.1. Tájékoztatáshoz való jog (GDPR 13-14. cikk)</h3>
                  <p className="text-gray-700 text-sm">
                    Az érintett jogosult arra, hogy az adatkezelés megkezdését megelőzően tájékoztatást kapjon személyes adatai kezeléséről. Ezt a jogot a jelen Tájékoztató biztosítja.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.2. Hozzáférési jog (GDPR 15. cikk)</h3>
                  <p className="text-gray-700 text-sm mb-2">
                    Az érintett jogosult arra, hogy visszajelzést kapjon arról, hogy személyes adatainak kezelése folyamatban van-e, és ha igen, jogosult a személyes adatokhoz hozzáférést kapni.
                  </p>
                  <p className="text-gray-600 text-sm">
                    <strong>Gyakorlás módja:</strong> E-mail küldése az Adatkezelő címére. Válaszadási határidő: <strong>30 nap</strong>.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.3. Helyesbítéshez való jog (GDPR 16. cikk)</h3>
                  <p className="text-gray-700 text-sm mb-2">
                    Az érintett jogosult arra, hogy kérésére az Adatkezelő indokolatlan késedelem nélkül helyesbítse a pontatlan személyes adatokat.
                  </p>
                  <p className="text-gray-600 text-sm">
                    <strong>Gyakorlás módja:</strong> A Beállítások menüben közvetlenül módosíthatók az adatok, vagy e-mail küldésével.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.4. Törléshez való jog – „elfeledtetéshez való jog" (GDPR 17. cikk)</h3>
                  <p className="text-gray-700 text-sm mb-2">
                    Az érintett jogosult arra, hogy kérésére az Adatkezelő indokolatlan késedelem nélkül törölje a rá vonatkozó személyes adatokat.
                  </p>
                  <p className="text-gray-600 text-sm mb-2">
                    <strong>Gyakorlás módja:</strong> A Beállítások / Fiók menüben a „Fiók törlése" gombbal, vagy e-mail küldésével.
                  </p>
                  <p className="text-gray-600 text-sm">
                    <strong>Korlátozás:</strong> Számviteli bizonylatok adatai 8 évig nem törölhetők (jogszabályi kötelezettség).
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.5. Adatkezelés korlátozásához való jog (GDPR 18. cikk)</h3>
                  <p className="text-gray-700 text-sm">
                    Az érintett kérheti az adatkezelés korlátozását, ha vitatja az adatok pontosságát, vagy az adatkezelés jogellenes, de az érintett ellenzi a törlést.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.6. Adathordozhatósághoz való jog (GDPR 20. cikk)</h3>
                  <p className="text-gray-700 text-sm mb-2">
                    Az érintett jogosult arra, hogy a rá vonatkozó személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja (JSON formátum).
                  </p>
                  <p className="text-gray-600 text-sm">
                    <strong>Gyakorlás módja:</strong> E-mail küldése az Adatkezelő címére. Az adatexport 30 napon belül díjmentesen biztosított.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.7. Tiltakozáshoz való jog (GDPR 21. cikk)</h3>
                  <p className="text-gray-700 text-sm mb-2">
                    Az érintett jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak jogos érdeken alapuló kezelése ellen.
                  </p>
                  <p className="text-gray-600 text-sm">
                    <strong>Közvetlen üzletszerzés elleni tiltakozás:</strong> Hírlevélről a levélben található linkkel vagy a Beállításokban iratkozhat le.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">9.8. Hozzájárulás visszavonásának joga (GDPR 7. cikk)</h3>
                  <p className="text-gray-700 text-sm">
                    Ha az adatkezelés hozzájáruláson alapul, az érintett jogosult a hozzájárulását bármikor visszavonni. A visszavonás nem érinti a visszavonás előtti adatkezelés jogszerűségét.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-8 mb-4">9.9. Joggyakorlás módja és határidők</h3>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <p className="text-gray-700 mb-3"><strong>Kapcsolatfelvétel:</strong></p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
                  <li>E-mail: toldf3l@gmail.com</li>
                  <li>A kérelem benyújtásához az érintett azonosítása szükséges (regisztrált e-mail címmel)</li>
                </ul>
                <p className="text-gray-700 mb-3"><strong>Válaszadási határidő:</strong></p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
                  <li>Alapeset: <strong>30 nap</strong></li>
                  <li>Összetett kérelem esetén: további <strong>60 nap</strong> (erről az érintettet tájékoztatjuk)</li>
                </ul>
                <p className="text-gray-700"><strong>Díjmentesség:</strong> Az első kérelem díjmentes. Ismétlődő vagy megalapozatlan kérelmek esetén adminisztratív díj számítható fel.</p>
              </div>
            </section>

            {/* 10. COOKIE-K */}
            <section id="section-10" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                10. COOKIE-K (SÜTIK) KEZELÉSE
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">10.1. A cookie-k fogalma</h3>
              <p className="text-gray-700 mb-4">
                A cookie-k (sütik) kis méretű szöveges fájlok, amelyeket a weboldal a Felhasználó eszközén (számítógép, tablet, mobiltelefon) tárol a böngészési élmény javítása és a weboldal működésének biztosítása érdekében.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">10.2. Alkalmazott cookie-k</h3>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Kategória</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cookie neve</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Cél</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Lejárat</th>
                      <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Jogalap</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-3 py-2 font-medium">Kötelező (elengedhetetlen)</td>
                      <td className="border border-gray-300 px-3 py-2">sb-*-auth-token</td>
                      <td className="border border-gray-300 px-3 py-2">Bejelentkezési munkamenet</td>
                      <td className="border border-gray-300 px-3 py-2">Munkamenet</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6(1)b</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2 font-medium">Kötelező</td>
                      <td className="border border-gray-300 px-3 py-2">cookie_consent</td>
                      <td className="border border-gray-300 px-3 py-2">Cookie beállítások tárolása</td>
                      <td className="border border-gray-300 px-3 py-2">1 év</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6(1)c</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-3 py-2 font-medium">Analitikai</td>
                      <td className="border border-gray-300 px-3 py-2">_ga, _ga_*</td>
                      <td className="border border-gray-300 px-3 py-2">Google Analytics - látogatói statisztikák</td>
                      <td className="border border-gray-300 px-3 py-2">14 hónap</td>
                      <td className="border border-gray-300 px-3 py-2">GDPR 6(1)a</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">10.3. Cookie beállítások kezelése</h3>
              <p className="text-gray-700 mb-4">
                A Felhasználó a cookie beállításokat az alábbi módokon kezelheti:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li><strong>Cookie banner:</strong> A weboldal első látogatásakor megjelenő sávon keresztül</li>
                <li><strong>Böngésző beállítások:</strong> A böngésző cookie beállításaiban (minden cookie törölhető vagy letiltható)</li>
              </ul>
              <p className="text-gray-600 text-sm">
                <strong>Megjegyzés:</strong> A kötelező cookie-k letiltása esetén a Szolgáltatás nem működik megfelelően.
              </p>
            </section>

            {/* 11. AUTOMATIZÁLT DÖNTÉSHOZATAL */}
            <section id="section-11" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                11. AUTOMATIZÁLT DÖNTÉSHOZATAL ÉS PROFILALKOTÁS
              </h2>
              
              <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-3">Az Adatkezelő nyilatkozata</h3>
                <p className="text-gray-700 mb-4">
                  A ToldFel szolgáltatás keretében az Adatkezelő:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li><strong>NEM alkalmaz</strong> olyan automatizált döntéshozatalt, amely az érintettre nézve joghatással járna vagy őt hasonlóképpen jelentős mértékben érintené (GDPR 22. cikk).</li>
                  <li><strong>NEM végez profilalkotást</strong> marketing vagy egyéb célokból.</li>
                  <li>A Szolgáltatás kizárólag a megadott funkciók (videófeltöltés, továbbítás) végrehajtására használja a Felhasználó adatait.</li>
                </ul>
              </div>
            </section>

            {/* 12. JOGORVOSLAT */}
            <section id="section-12" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                12. JOGORVOSLATI LEHETŐSÉGEK
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">12.1. Panasz az Adatkezelőnél</h3>
              <p className="text-gray-700 mb-4">
                Az érintett elsődlegesen az Adatkezelőhöz fordulhat panaszával:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <p className="text-gray-700">E-mail: toldf3l@gmail.com</p>
                <p className="text-gray-700">Tárgy: „Adatvédelmi panasz"</p>
                <p className="text-gray-600 text-sm mt-2">Válaszadási határidő: 30 nap</p>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">12.2. Panasz a felügyeleti hatóságnál</h3>
              <p className="text-gray-700 mb-4">
                Ha az érintett úgy ítéli meg, hogy az adatkezelés a GDPR vagy az Info tv. rendelkezéseibe ütközik, panasszal élhet a felügyeleti hatóságnál:
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
                <h4 className="font-semibold text-gray-800 mb-3">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</h4>
                <ul className="text-gray-700 space-y-1">
                  <li><strong>Cím:</strong> 1055 Budapest, Falk Miksa utca 9–11.</li>
                  <li><strong>Postacím:</strong> 1363 Budapest, Pf. 9.</li>
                  <li><strong>Telefon:</strong> +36 1 391 1400</li>
                  <li><strong>E-mail:</strong> ugyfelszolgalat@naih.hu</li>
                  <li><strong>Weboldal:</strong> <a href="https://naih.hu" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">naih.hu</a></li>
                </ul>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">12.3. Bírósági jogorvoslat</h3>
              <p className="text-gray-700 mb-4">
                Az érintett a GDPR 79. cikke alapján bírósághoz fordulhat, ha megítélése szerint a személyes adatainak kezelése a GDPR-nak nem megfelelő módon történik.
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li>A per az érintett lakóhelye vagy tartózkodási helye szerinti törvényszék előtt is megindítható.</li>
                <li>Az adatvédelmi perek illetékmentesek.</li>
                <li>Törvényszéki eljárásban kötelező a jogi képviselet.</li>
              </ul>
            </section>

            {/* 13. MÓDOSÍTÁS */}
            <section id="section-13" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                13. A TÁJÉKOZTATÓ MÓDOSÍTÁSA
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">13.1. Módosítás joga</h3>
              <p className="text-gray-700 mb-4">
                Az Adatkezelő fenntartja a jogot, hogy jelen Tájékoztatót egyoldalúan módosítsa. A módosítás indoka lehet:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-1">
                <li>Jogszabályi változások (GDPR, Info tv. módosítása)</li>
                <li>Új funkciók bevezetése</li>
                <li>Adatfeldolgozók változása</li>
                <li>Hatósági vagy bírósági jogértelmezés változása</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">13.2. Értesítés a módosításról</h3>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li><strong>Lényeges változás esetén:</strong> Az Adatkezelő e-mailben értesíti a Felhasználókat legalább <strong>15 nappal</strong> a hatálybalépés előtt.</li>
                <li><strong>Nem lényeges változás esetén:</strong> A módosított Tájékoztató a weboldalon történő közzététellel lép hatályba.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">13.3. Módosítás korlátai</h3>
              <p className="text-gray-700 mb-4">A módosítás nem eredményezheti:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-1">
                <li>az érintettek jogainak csorbítását a GDPR-ban foglaltakhoz képest;</li>
                <li>visszamenőleges hatályú adatkezelés jogszerűsítését;</li>
                <li>a már megadott hozzájárulások hatályának kiterjesztését.</li>
              </ul>
            </section>

            {/* 14. ZÁRÓ RENDELKEZÉSEK */}
            <section id="section-14" className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-blue-500">
                14. ZÁRÓ RENDELKEZÉSEK
              </h2>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">14.1. Alkalmazandó jog</h3>
              <p className="text-gray-700 mb-4">
                A jelen Tájékoztatóra és az Adatkezelő adatkezelési tevékenységére a magyar jog az irányadó, különös tekintettel a GDPR-ra és az Info tv.-re.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">14.2. Részleges érvénytelenség</h3>
              <p className="text-gray-700 mb-4">
                Ha a jelen Tájékoztató valamely rendelkezése érvénytelennek vagy végrehajthatatlannak minősül, az nem érinti a többi rendelkezés érvényességét.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">14.3. Kapcsolat az ÁSZF-fel</h3>
              <p className="text-gray-700 mb-4">
                Jelen Tájékoztató az Általános Szerződési Feltételek elválaszthatatlan mellékletét képezi. Az ÁSZF és a Tájékoztató közötti ellentmondás esetén az adatvédelmi kérdésekben a jelen Tájékoztató rendelkezései az irányadók.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">14.4. Dokumentum azonosítás</h3>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300 text-sm">
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-50">Dokumentum címe</td>
                      <td className="border border-gray-300 px-4 py-2">Adatvédelmi Tájékoztató</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-50">Verziószám</td>
                      <td className="border border-gray-300 px-4 py-2">1.0</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-50">Hatályba lépés</td>
                      <td className="border border-gray-300 px-4 py-2">2026. január 24.</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-50">Kiadó</td>
                      <td className="border border-gray-300 px-4 py-2">Tóth Máté EV.</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-50">Dokumentum típusa</td>
                      <td className="border border-gray-300 px-4 py-2">Nyilvános</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">14.5. Verzió-történet</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Dátum</th>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Verzió</th>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Változás leírása</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">2026.01.24.</td>
                      <td className="border border-gray-300 px-4 py-2">1.0</td>
                      <td className="border border-gray-300 px-4 py-2">Első kiadás</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* Footer */}
            <div className="mt-12 pt-8 border-t border-gray-200 text-center text-gray-500 text-sm">
              <p>© 2026 ToldFel. Minden jog fenntartva.</p>
              <p className="mt-2">
                Jelen Adatvédelmi Tájékoztató a weboldalon érhető el: toldfel.hu/privacy-policy
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
